import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '@fluentui/react';
import { Header } from '../organisms';

import styles from './LandingPageTemplate.module.scss';

export interface ILandingPageTemplate {
	content: { [lang: string]: string };
	onCreate: () => void;
	onHome: () => void;
}

export const LandingPageTemplate = (props: ILandingPageTemplate) => {
	const { t, i18n } = useTranslation();
	const contentRef = useRef<HTMLDivElement>(null);

	const fragment = document.createRange().createContextualFragment(props.content[i18n.language] ?? props.content['en']);
	if (contentRef.current !== null) {
		while (contentRef.current.children.length > 0) {
			contentRef.current.removeChild(contentRef.current.children[0]);
		}
		contentRef.current.textContent = null;
		contentRef.current.appendChild(fragment);
	}

	return (
		<div className={styles.globalDihkFont + ' ' + styles.pageContent}>
			<Header label={t('header.label')} onClick={props.onHome} />
			<div>
				<div className={styles.headerImage} />
				<div ref={contentRef}></div>
				<div className={styles.buttonSection}>
					<PrimaryButton
						className={styles.submitButton}
						text={t('landingpage.submit')}
						iconProps={{ iconName: 'PageEdit' }}
						onClick={props.onCreate}
					/>
				</div>
			</div>
		</div>
	);
};
